import { ProgressBar } from '@platform/components';

export type HubProgressBarProps = {
  completed: number;
  total: number;
};

export const HubProgressBar = ({ completed, total }: HubProgressBarProps) => {
  return (
    <div className='flex flex-col md:flex-row gap-4 md:mt-8 md:items-center'>
      <div className='text-xs text-gray-400 mt-4 md:mt-0'>
        {completed} of {total} tasks complete
      </div>
      <div className='md:flex-grow'>
        <ProgressBar value={(completed / total) * 100} rounded valueLocation='none' />
      </div>
    </div>
  );
};
